// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Buttons_buttonsContainer__lSqFt","icons":"Buttons_icons__Y8oXe"};